import { Region } from '@lemon8/web-app-shared/i18n';
import { atom } from 'jotai';

export const $LegalRegion = atom({
  region: Region.us,
});

$LegalRegion.debugLabel = '$LegalRegion';
